import script from "./CheckOutFlowPayment.vue?vue&type=script&setup=true&lang=js"
export * from "./CheckOutFlowPayment.vue?vue&type=script&setup=true&lang=js"

import "./CheckOutFlowPayment.vue?vue&type=style&index=0&id=135f0fa6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-135f0fa6"]])

export default __exports__